/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Bar from '../../components/task/bar';
import Sidebar from '../../components/task/shop/sidebar';
import Form from '../../containers/error-tracking/form.js';
import {tasksUpdate} from "../../store/tasks/actions";
import {getCurrentError, getCurrentErrorDetails} from "../../store/quality/selectors";
import {errorDeselect, getErrorDetails} from "../../store/quality/actions";
import {returnId} from "../../common/utilities";
import {ts_translate} from "../../common/clientTranslate";

const ContentWrapper = styled(FlexRootWrapper)`
	flex-direction: row;
`;

class ErrorTrackingPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // order, task, query (task tracking elements)
        const {getErrorDetails, error} = this.props;
        getErrorDetails(returnId(error._links.self.href));
    }

    render() {
        const {error, errorDeselect, errorTask} = this.props;
        const {close} = this.props;
        let departments = '';

        if (!R.isEmpty(errorTask)) {
            departments = R.join(', ', R.pluck('name', errorTask.taskEntity.departmentEntityList));
        }

        return (
            <FlexRootWrapper>
                <Bar
                    longNumber={error.erpnumber}
                    task={errorTask}
                    onClose={errorDeselect}

                    color="#f43d3d"
                />

                <ContentWrapper>
                    <Sidebar
                        // taskImage={this.state.image}
                        taskHeadLine={ts_translate("Fehlerbericht") + " "}
                        color="#f43d3d"
                        taskShortNumber={error.erpnumber}
                        taskTotalQuantity={error.quantity}
                        taskCustomer={error.client}
                        taskDate={error.date}
                        noWeek={true}
                        taskDepartments={departments}
                    />
                    <Form/>
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default connect(
    (state) => ({
        error: getCurrentError(state),
        errorTask: getCurrentErrorDetails(state),
    }), {
        errorDeselect,
        tasksUpdate,
        getErrorDetails
    }
)(ErrorTrackingPage);



// WEBPACK FOOTER //
// ./src/containers/error-tracking/index.js